export function setBateriiuzateLoading (state, loading = false) {
  state.bateriiuzateLoading = loading
}

export function setBateriiuzate (state, data ) {
  state.bateriiuzate = data.bateriiuzate.data
  state.bateriiuzateCurrentPage = data.bateriiuzate.current_page
  state.bateriiuzateLastPage = data.bateriiuzate.last_page
  state.bateriiuzatePerPage = data.bateriiuzate.per_page
  state.bateriiuzateTotal = data.bateriiuzate.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}
